import { FilterTitleObject, GroupFilter } from 'types/groupService';

const GROUPS_FILTERS_TITLES: FilterTitleObject<GroupFilter> = Object.freeze({
  [GroupFilter.ALL]: 'All Active',
  [GroupFilter.NEW_LEAD]: 'Lead',
  [GroupFilter.QUOTING]: 'Quotes',
  [GroupFilter.ENROLLING]: 'Enrollments',
  [GroupFilter.SUBMITTED]: 'Submitted',
  [GroupFilter.RENEWAL]: 'Renewals',
  [GroupFilter.SOLD]: 'Installed / Sold',
  [GroupFilter.ARCHIVED]: 'Archived',
  [GroupFilter.DORMANT]: 'Dormant',
});

export { GROUPS_FILTERS_TITLES };
